import React, { useState } from 'react';
import { BASE_URL } from '../config/config';
import useFetch from '../hooks/useFetch';
import ReactPaginate from 'react-paginate';

import Helmet from '../components/Helmet';
import CommonSection from '../components/CommonSection';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';

import ProductCard from '../components/ProductCard';
import BookingForm from '../components/BookingForm';

const PRODUCT__CATEGORY = [
  {
    display: 'Battery',
  },

  {
    display: 'Disk',
  },

  {
    display: 'Seat',
  },

  {
    display: 'Wheel',
  },
  {
    display: 'Shock Absorber',
  },
  {
    display: 'Oil',
  },
];

const Products = () => {
  const { data: products, isPending, error } = useFetch(`${BASE_URL}/products`);
  const [pageNumber, setPageNumber] = useState(0);
  const productPerPage = 9;
  const visitedPage = pageNumber * productPerPage;
  const displayPage = products
    .slice(visitedPage, visitedPage + productPerPage)
    .map(item => <ProductCard item={item} />);

  const pageCount = Math.ceil(products.length / productPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <Helmet title="Car Booking">
    <section className="pt-0">
    <CommonSection title="Upload Car" />
      <Container>
        <Row>
          <Col lg="12" className="mt-5">
              <BookingForm />
          </Col>
        </Row>
      </Container>
    </section>
  </Helmet>
  );
};

export default Products;
